// extracted by mini-css-extract-plugin
export default {"card":"QuickActionCard_card__J+KwK","iconCircle":"QuickActionCard_iconCircle__ItGb2","label":"QuickActionCard_label__1Ih8e"};